module.exports = new __parcel__URL__("agile.52407441.svg").toString();